import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import classnames from 'classnames';

import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';
import { RESULTS_TYPE } from 'dpl/constants/query_params';
import FixedTooltipPortal from 'dpl/common/tooltip/components/FixedTooltipPortal';

import useSearchFiltering from '../hooks/useSearchFiltering';
import SearchFilters from './SearchFilters';
import MobileFilterButtons from './MobileFilterButtons';

const IS_BOT_UA = window.__DPL_BOT_UA;

export default function MobileFilterMenu({ totalItemCount }) {
  const { isFiltersModalOpen, toggleFilters } = useSearchFiltering();
  const queryParams = useSelector(state => state.queryParams);

  const initialResultType = IS_BOT_UA
    ? RESULTS_TYPES.BREEDERS
    : RESULTS_TYPES.PUPPIES;
  const resultsType = queryParams[RESULTS_TYPE] || initialResultType;

  return (
    <FixedTooltipPortal
      className="MobileFilterMenu"
      isVisible={isFiltersModalOpen}
      onCloseClick={toggleFilters}
      wrapperClassName={classnames({ 'top-1': isFiltersModalOpen })}
      style={{ paddingBottom: 0, maxHeight: '100%' }}
    >
      <p className="font-20 font-serif fw-medium bb b--default pt3 pb5 mb6">
        Filter Results ({totalItemCount})
      </p>
      <SearchFilters className="pb8" />

      <MobileFilterButtons
        className="sticky bottom-0 bg-white pv6"
        setIsMenuOpen={toggleFilters}
        totalItemCount={totalItemCount}
        resultsType={resultsType}
      />
    </FixedTooltipPortal>
  );
}

MobileFilterMenu.propTypes = {
  totalItemCount: PropTypes.number.isRequired
};
